export default {
  API_BASE_URL: 'https://api.didomi.io',
};
